import {IBaseFetchOptions, IBaseResponse, IEndpointsMap} from 'commerceAPI/custom-apis/ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	CUSTOMER_EXISTS: {
		path: 'exist',
		method: 'POST'
	},
	RESET_CUSTOMER_PASSWORD: {
		path: 'reset-password',
		method: 'POST'
	},
	CHECK_TOKEN_VALIDITY : {
		path: 'check-token-validity',
		method: 'POST'
	},
	SET_NEW_CUSTOMER_PASSWORD: {
		path: 'new-password',
		method: 'POST'
	},
	LOGIN_ON_BEHALF : {
		path: 'login-on-behalf',
		method: 'POST'
	}
};

enum ECustomerExistStatus {
	NOT_REGISTERED = 'notRegistered',
	REGISTERED = 'registered',
	EXTERNALLY_REGISTERED = 'externallyRegistered'
}

export interface ICheckIfCustomerExistsOptions extends IBaseFetchOptions {
	body : {
		email: string
	};
}

export interface ICheckIfCustomerExistsResponse extends IBaseResponse {
	existingStatus: ECustomerExistStatus
	shouldResetPassword?: boolean
}

export interface IResetCustomerPasswordOptions extends IBaseFetchOptions {
	body : {
		email: string
		languageCode: string
		countryCode: string
	};
}

export interface IResetCustomerPasswordResponse extends IBaseResponse {
	message: string
}

export interface ICheckResetTokenValidityOptions extends IBaseFetchOptions {
	body : {
		token: string
	};
}

export interface ICheckResetTokenValidityResponse extends IBaseResponse {
	isValid: boolean
}

export interface ISetNewCustomerPasswordOptions extends IBaseFetchOptions {
	body : {
		token: string
		password: string
		languageCode: string
		countryCode: string
	};
}

export interface ISetNewCustomerPasswordResponse extends IBaseResponse {
	message: string
}

export interface ILoginOnBehalfOptions extends IBaseFetchOptions {
	body: {
		loginId: string
	}
}

export interface ILoginOnBehalfResponse extends IBaseResponse {
	result: ILoginOnBehalfResult
}

export interface ILoginOnBehalfResult {
	access_token: string
	c_crmId?: string
	customer_id: string
	enc_user_id: string
	expires_in: number
	id_token: string
	idp_access_token?: string
	idp_refresh_token?: string
	ok: boolean
	refresh_token: string
	refresh_token_expires_in: number
	token_type: string
	usid: string

}
